module.exports = __webpack_public_path__ + "722ca7676731c0eced7ba2a04ccfd271.gif";